import * as React from 'react';
import _ from 'lodash';
import {Typography} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import {Download} from '@mui/icons-material';
import {download} from '../../../utils/download';
import {getValueBySurvey} from '../helpers/mapping';
import {IPageProps} from '../index';
import CustomTable from '../../../shared/Table';

interface INumeroValutatoreProps {
    page: IPageProps | undefined,
    submissions: {
        uoa_id: number,
        uoa_name: string,
        uoa_custom_field_ente_proponente_51: string,
        user_id: number,
        user_name: string,
        totale_punteggi_pesati: number,
    }[];
}

interface IUserProps {
    id: number,
    name: string,
}

const EvaluationsOverview = ({page, submissions}: INumeroValutatoreProps) => {
    const users: IUserProps[] = _.sortBy(
        _.uniqBy(submissions, 'user_id')
        .map(submission => ({id: submission.user_id, name: submission.user_name})),
        'name'
    );

    const columns: any[] = [
        ...[
            'Progetto',
            'Ente proponente',
        ],
        ...users.map(({name}) => name),
        ...[
            'Numero di valutazioni',
            'Totale'
        ]
    ];
    const data: any = {};
    let rows: any;

    submissions.forEach(function (submission) {
        const score = Number(getValueBySurvey(page, submission, 'score'));

        if (data.hasOwnProperty(submission.uoa_id)) {
            data[submission.uoa_id][submission.user_id] = score;
            data[submission.uoa_id].count = data[submission.uoa_id].count + 1;
            data[submission.uoa_id].sum = data[submission.uoa_id].sum + score;
        } else {
            data[submission.uoa_id] = {
                name: submission.uoa_name,
                field: submission.uoa_custom_field_ente_proponente_51,
                [submission.user_id]: score,
                count: 1,
                sum: score
            };
        }
    })

    rows = Object.values(data)
        .map((item: any) => {
            return [
                item.name,
                item.field,
                ...users.map(({id}) => item[id] ?? ''),
                item.count,
                Number.isFinite(item.sum) ? (item.sum / item.count).toFixed(2) : 0,
            ]
        })

    rows.sort(function (a: any, b: any) {
        if (a[0] > b[0]) {
            return 1;
        }

        if (a[0] < b[0]) {
            return -1;
        }

        return 0;
    });

    const handleDownload = () => {
        download([columns, ...rows], 'Numero di valutazioni per progetto')
    }

    return (
        <>
            <div className='content-title'>
                <Typography variant='h5'>
                    Overview di tutti i progetti
                </Typography>
                <IconButton onClick={handleDownload}>
                    <Download fontSize='small'/>
                </IconButton>
            </div>
            <CustomTable
                columns={columns}
                rows={rows}
                numberRows={Array.from({length: (users.length + 2)}, (_, i) => i + 1)}/>
        </>
    );
};

export default EvaluationsOverview;
